export default __webpack_public_path__ + "static/media/Sign-Yellow-24x24.37e975d6.svg";